import { useIntl } from 'react-intl';

import type { ButtonVariants } from '@xing-com/button';
import { Link } from '@xing-com/link';
import { addParams } from '@xing-com/xing-tracking';

import * as Styled from './create-job-button.styled';

type CreateJobButtonProps = {
  showMarker?: boolean;
  variant?: ButtonVariants;
};

export const CreateJobButton: React.FC<CreateJobButtonProps> = ({
  showMarker = false,
  variant = 'primary',
}) => {
  const { formatMessage } = useIntl();
  const targetURL = 'https://www.xing.com/recruiting/jobs/create';
  const trackingURL = addParams(targetURL, {
    nwt_nav: 'boneyard_job_ad',
    sc_cmp: 'oow5eb8bc92',
  });
  const commonProps = {
    'data-testid': 'styled-create-job-button',
    to: trackingURL,
    variant,
  };

  return (
    <>
      <Styled.ButtonSmallWhenTopBar {...commonProps} $size="small" size="small">
        {formatMessage({ id: 'MAINNAV_CREATE_JOB' })}
      </Styled.ButtonSmallWhenTopBar>
      <Styled.ButtonSmallWhenTopBar
        {...commonProps}
        $size="medium"
        size="medium"
      >
        {formatMessage({ id: 'MAINNAV_JOBS_EASY_CREATE' })}
      </Styled.ButtonSmallWhenTopBar>
      {showMarker ? (
        <Link to={trackingURL}>
          <Styled.CreateJobMarker $size="medium" variant="strong">
            {formatMessage({ id: 'MAINNAV_JOBS_EASY_CREATE_MARKER' })}
          </Styled.CreateJobMarker>
          <Styled.CreateJobMarker $size="small" variant="strong">
            {formatMessage({
              id: 'MAINNAV_JOBS_EASY_CREATE_MARKER_MOBILE',
            })}
          </Styled.CreateJobMarker>
        </Link>
      ) : null}
    </>
  );
};
